import { getServiceWallets } from '@api/FW/serviceWallets/serviceWallets';
import { IServiceWallet } from '@api/FW/serviceWallets/types';
import { getWallet, WalletRequest } from '@api/FW/wallets/wallets.api';
import {
	filterTransitWalletType,
	getBlockedResourcesWallets,
	getIndividualWallets,
	getOrdinaryWallets,
	getTransitWallets,
} from '@app/services/dataFilters';
import { saveLocalStorageData } from '@app/services/localStorage.service';
import { LocalStorageItems } from '@app/shared/constants/localStorageItems';
import { RootState } from '@app/store/store';
import { IWalletItem } from '@interfaces/FW/Wallets';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export interface WalletsSlice {
	data: IWalletItem[];
	noServiceWallets: IWalletItem[];
	ordinaryWallets: IWalletItem[];
	individualWallets: IWalletItem[];
	transitWallets: IServiceWallet[];
	serviceWallets: IServiceWallet[];
	blockedResourcesWallets: IServiceWallet[];
}

export const doGetWallet = createAsyncThunk(
	'getWallet',
	async (payload: WalletRequest | undefined, { getState, rejectWithValue }) => {
		const counterparty = (getState() as RootState).user.client?.counterparty;

		if (!counterparty) return rejectWithValue('Client not found');

		return getWallet(payload, counterparty)
			.then((res) => {
				saveLocalStorageData(LocalStorageItems.wallets, res);
				return res;
			})
			.catch((err) => {
				return rejectWithValue(err);
			});
	},
);

export const doGetServiceWallets = createAsyncThunk(
	'getServiceWallets',
	async (_, { getState, rejectWithValue }) => {
		const counterparty = (getState() as RootState).user.client?.counterparty;

		if (!counterparty) return rejectWithValue('Client not found');

		return getServiceWallets(counterparty)
			.then((loadData) => {
				return loadData;
			})
			.catch((err) => {
				return rejectWithValue(err);
			});
	},
);

const walletsSlice = createSlice({
	name: 'wallets',
	initialState: { data: [] as IWalletItem[] } as WalletsSlice,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(doGetWallet.fulfilled, (state, action) => {
			state.data = action.payload;
			state.noServiceWallets = filterTransitWalletType(action.payload);
			state.ordinaryWallets = getOrdinaryWallets(action.payload);
			state.individualWallets = getIndividualWallets(action.payload);
		});
		builder.addCase(doGetServiceWallets.fulfilled, (state, action) => {
			state.serviceWallets = action.payload;
			state.transitWallets = getTransitWallets(action.payload);
			state.blockedResourcesWallets = getBlockedResourcesWallets(action.payload);
		});
	},
});

export default walletsSlice.reducer;
